import { forwardRef } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';

import Switch from 'src/common/primitives/Switch';

import { FormFieldProps } from './FormField';

type FormFieldSwitchProps<T> = Pick<
  FormFieldProps<T>,
  'inputProps' | 'label' | 'helperText' | 'error'
>;

export const FormFieldSwitch = forwardRef(function _FormFieldSwitch<T>(
  { inputProps, label = '', helperText = '', error }: FormFieldSwitchProps<T>,
  ref: React.ForwardedRef<unknown>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      inputId={inputProps.id}
      helperText={helperText}
      error={error}
    >
      <Switch
        data-testid={inputProps.id}
        label={label}
        inputProps={inputProps}
        ref={ref}
      />
    </DefaultFormFieldLayout>
  );
});
